class ProductCrossSell {
  constructor(form) {
    this.form = form;
    this.selects = Array.from(form.querySelectorAll('[data-cross-sell-option]'));
    this.variantInput = form.querySelector('[data-cross-sell-variant-id]');
    this.price = form.querySelector('[data-cross-sell-price]');
    this.comparePrice = form.querySelector('[data-cross-sell-compare-price]');
    this.button = form.querySelector('button[type="submit"]');

    try {
      this.variants = JSON.parse(form.querySelector('[data-cross-sell-variants]')?.textContent || '[]');
    } catch {
      this.variants = [];
    }

    form.addEventListener('change', this.handleChange);
    form.addEventListener('click', this.handleClick);
    form.addEventListener('keydown', this.handleKeydown);
    this.updateVariant();
  }

  handleChange = (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('[data-cross-sell-option]')) {
      this.updateVariant();
    }
  };

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-cross-sell-option-trigger]');
    if (trigger instanceof HTMLButtonElement) {
      const option = trigger.closest('.supra-product-cross-sell__option');
      const menu = option?.querySelector('[data-cross-sell-option-menu]');
      const willOpen = menu instanceof HTMLElement && menu.hidden;

      this.closeMenus();
      if (menu instanceof HTMLElement && willOpen) {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const valueButton = event.target.closest('[data-cross-sell-option-value]');
    if (!(valueButton instanceof HTMLButtonElement)) return;

    const option = valueButton.closest('.supra-product-cross-sell__option');
    const select = option?.querySelector('[data-cross-sell-option]');
    if (!(select instanceof HTMLSelectElement)) return;

    select.value = valueButton.dataset.crossSellOptionValue || '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
    this.closeMenus();
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape') {
      this.closeMenus();
    }
  };

  closeMenus() {
    this.form.querySelectorAll('[data-cross-sell-option-menu]').forEach((menu) => {
      if (menu instanceof HTMLElement) menu.hidden = true;
    });
    this.form.querySelectorAll('[data-cross-sell-option-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  updateVariant() {
    this.selects.forEach((select) => {
      const option = select.closest('.supra-product-cross-sell__option');
      const label = option?.querySelector('[data-cross-sell-option-label]');
      if (label) label.textContent = select.value;

      option?.querySelectorAll('[data-cross-sell-option-value]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        if (button.dataset.crossSellOptionValue === select.value) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    });

    const selectedOptions = this.selects.map((select) => ({
      index: Number(select.dataset.optionIndex),
      value: select.value,
    }));

    const matchingVariants = this.variants.filter((variant) =>
      selectedOptions.every(({ index, value }) => variant.options?.[index] === value)
    );
    const variant = matchingVariants.find((item) => item.available) || matchingVariants[0];

    if (this.variantInput instanceof HTMLInputElement) {
      this.variantInput.value = variant?.id || '';
    }

    if (this.price && variant?.price) {
      this.price.textContent = variant.price;
    }

    if (this.comparePrice) {
      this.comparePrice.textContent = variant?.comparePrice || '';
      this.comparePrice.hidden = !variant?.comparePrice;
    }

    if (this.button instanceof HTMLButtonElement) {
      this.button.disabled = !variant?.available;
      this.button.textContent = variant?.available ? 'Add to Cart' : 'Sold Out';
    }
  }
}

document.querySelectorAll('form.supra-product-cross-sell').forEach((form) => {
  if (form instanceof HTMLFormElement) new ProductCrossSell(form);
});
